/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { BsFillArrowLeftSquareFill, BsFillArrowRightSquareFill } from 'react-icons/bs';
import { useMediaQuery } from 'react-responsive';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import styles from './styles.module.css';

const SliderGallery = ({ galleryImages, isFetching }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  if (isFetching) {
    return <div className={styles.loading}>Cargando...</div>;
  }

  if (!galleryImages?.length) {
    return <div className={styles.empty__gallery} />;
  }

  const shouldShowNavigation = galleryImages.length > 1;

  return (
    <div className={styles.gallery__container}>
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={20}
        slidesPerView={isMobile ? 1 : 'auto'}
        loop={galleryImages.length > 1}
        navigation={shouldShowNavigation ? {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        } : false}
        pagination={shouldShowNavigation}
        className={styles.gallery}
      >
        {galleryImages.map((image) => (
          <SwiperSlide key={image.id} className={styles.slide}>
            <img
              src={image.url}
              alt={image.name}
              className={styles.slide__image}
            />
          </SwiperSlide>
        ))}
        {shouldShowNavigation && (
          <>
            <button
              type="button"
              className={`swiper-button-prev ${styles.nav_button} ${styles.nav_button_prev}`}
              aria-label="Previous slide"
            >
              <BsFillArrowLeftSquareFill />
            </button>
            <button
              type="button"
              className={`swiper-button-next ${styles.nav_button} ${styles.nav_button_next}`}
              aria-label="Next slide"
            >
              <BsFillArrowRightSquareFill />
            </button>
          </>
        )}
      </Swiper>
    </div>
  );
};

SliderGallery.propTypes = {
  galleryImages: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      alt: PropTypes.string,
    }),
  ),
  isFetching: PropTypes.bool,
};

SliderGallery.defaultProps = {
  galleryImages: [],
  isFetching: false,
};

export default SliderGallery;
